import React from "react";
import logo from "../assets/img/logo_hob.png";

function Footer() {
  return (
    <footer className="foteri">
      <div className="container">
        {/* --- Top Section --- */}
        <div className="footer-top d-flex flex-column flex-md-row justify-content-between align-items-stretch">
          {/* Left Section */}
          <div className="mb-4 mb-md-0 text-start">
            <div
              className="d-flex flex-column align-items-center mb-2"
              style={{ width: "fit-content" }}
            >
              <img
                src={logo}
                alt="HoB Studio Logo"
                className="logo-img mb-1"
                style={{ width: "50px" }}
              />
              <h5 className="fw-bold mb-3 text-center">HoB Studio</h5>
            </div>

            <div className="footer-address text-start">
              <p className="mb-1">House of Berechet L.L.C</p>
              <p className="mb-1">Rr. Ukshin Hoti, Prime Residence 2</p>
              <p className="mb-1">Kosovë, Prishtinë, 10000</p>
            </div>
          </div>

          {/* Right Section */}
          <div className="footer-right d-flex flex-column justify-content-between text-md-end text-start">
            {/* Top part */}
            <div>
              <p className="mb-1">www.hobstudio.tv</p>
              <p className="mb-1">info@hobstudio.tv</p>
            </div>

            {/* Bottom part */}
            <div>
              <a href="/terms-and-conditions" className="footer-link me-3">
                Terms and Conditions
              </a>
              <a href="/imprint" className="footer-link">
                Imprint
              </a>
            </div>
          </div>
        </div>

        {/* --- Divider --- */}
        <hr className="gradient-line" />

        {/* --- Bottom Text --- */}
        <div className="footer-text">
          <p>Copyright. All rights reserved</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
